import axiosClient from 'utils/axiosClient';
import api from 'api';

const getBenefits = async (data: any) => {
	const response = await axiosClient.get(api.RATING.BENEFITS.BENEFITS, {params: data});
	return response.data;
};

const getBenefitByID = async (id: any) => {
	const response = await axiosClient.get(api.RATING.BENEFITS.BENEFITS + `/` + id);
	return response.data;
};

const createBenefit = async (data: any) => {
	const response = await axiosClient.post(api.RATING.BENEFITS.BENEFITS, data);
	return response.data;
};

const updateBenefit = async (id: number, data: any) => {
	const response = await axiosClient.patch(api.RATING.BENEFITS.BENEFITS + `/` + id, data);
	return response.data;
};

const deleteBenefit = async (id: number) => {
	const response = await axiosClient.delete(api.RATING.BENEFITS.BENEFITS + `/` + id);
	return response.data;
};

const archiveBenefit = async (id: number) => {
	const response = await axiosClient.patch(api.RATING.BENEFITS.BENEFITS + `/` + id + '/archive');
	return response.data;
};

const activateBenefit = async (id: number) => {
	const response = await axiosClient.patch(api.RATING.BENEFITS.BENEFITS + `/` + id + '/activate');
	return response.data;
};

const service = {
	getBenefits,
	getBenefitByID,
	createBenefit,
	updateBenefit,
	deleteBenefit,
	archiveBenefit,
	activateBenefit
};

export default service;
